import { useEffect, useState } from "react";
import { NAV_LINKS, CATEGORIES } from "@/mocks/content";

export function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <button
      type="button"
      aria-label="回到顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className={
        "fixed right-5 bottom-5 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-all hover:bg-primary-600 md:right-8 md:bottom-8 " +
        (show ? "opacity-100" : "pointer-events-none opacity-0")
      }
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}

export default function Footer() {
  return (
    <footer className="w-full bg-background-950 text-foreground-200">
      <div className="mx-auto max-w-[1400px] px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-xl font-black text-background-50">
                <i className="ri-search-eye-line"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-xl font-black text-foreground-50">爆源</span>
                <span className="text-[10px] font-medium tracking-[0.2em] text-foreground-500">
                  幕后调查 · 揭秘来源
                </span>
              </span>
            </a>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-foreground-400">
              不止看到热搜，更看清爆料背后的链条。深挖幕后，揭秘来源，给每一份爆料以可信的标注。
            </p>
            <div className="mt-5 flex items-center gap-2">
              <a
                href="#top"
                aria-label="微博"
                className="flex h-9 w-9 items-center justify-center rounded-md bg-foreground-800 text-foreground-200 transition-colors hover:bg-primary-500 hover:text-background-50"
              >
                <i className="ri-weibo-line"></i>
              </a>
              <a
                href="#top"
                aria-label="微信"
                className="flex h-9 w-9 items-center justify-center rounded-md bg-foreground-800 text-foreground-200 transition-colors hover:bg-primary-500 hover:text-background-50"
              >
                <i className="ri-wechat-line"></i>
              </a>
              <a
                href="#top"
                aria-label="抖音"
                className="flex h-9 w-9 items-center justify-center rounded-md bg-foreground-800 text-foreground-200 transition-colors hover:bg-primary-500 hover:text-background-50"
              >
                <i className="ri-tiktok-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-bold tracking-widest text-foreground-50">栏目导航</h4>
            <ul className="flex flex-col gap-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="inline-flex items-center gap-2 text-sm text-foreground-400 transition-colors hover:text-accent-400">
                    <span className="h-1 w-1 rounded-full bg-foreground-600"></span>
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-bold tracking-widest text-foreground-50">垂直追踪</h4>
            <ul className="flex flex-col gap-2.5">
              {CATEGORIES.map((c) => (
                <li key={c.key}>
                  <a href="#category" className="inline-flex items-center gap-2 text-sm text-foreground-400 transition-colors hover:text-accent-400">
                    <span className="h-1 w-1 rounded-full bg-foreground-600"></span>
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-bold tracking-widest text-foreground-50">联系我们</h4>
            <p className="text-sm leading-relaxed text-foreground-400">
              投稿爆料、选题线索或商务合作，欢迎邮件联系。
            </p>
            <a
              href="mailto:contact@baoyuan-ent.com"
              className="mt-3 inline-flex items-center gap-2 whitespace-nowrap text-sm font-semibold text-accent-400 hover:text-accent-300"
            >
              <i className="ri-mail-send-line"></i> contact@baoyuan-ent.com
            </a>
            <div className="mt-5 rounded-md border border-foreground-800 p-4">
              <p className="text-xs leading-relaxed text-foreground-500">
                <span className="font-semibold text-foreground-300">投稿提示：</span>
                请附上可交叉核实的时间、地点与材料，编辑部承诺对信源身份严格保密。
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-foreground-800 pt-6 sm:flex-row">
          <p className="text-center text-xs text-foreground-500 sm:text-left">
            © {new Date().getFullYear()} 爆源娱乐 BaoYuan Entertainment. 保留所有权利。本站内容仅供读者参考，请理性看待娱乐信息。
          </p>
          <a href="#top" className="inline-flex items-center gap-1.5 whitespace-nowrap text-xs font-medium text-foreground-400 transition-colors hover:text-accent-400">
            <i className="ri-arrow-up-line"></i> 回到顶部
          </a>
        </div>
      </div>
    </footer>
  );
}